var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: {
        padding: "30px 15px 30px 15px",
        "background-color": "#fff",
        margin: "0"
      }
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-title" }, [
                  _vm._v("About UNIFI Property")
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "16px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "UNIFI Property is a forward-thinking platform designed for off-the-plan real estate, aimed at transforming how new properties are marketed and sold. Founded by siblings Loretta and Michael Cavallaro, who bring 24 years of combined experience as off-the-plan real estate specialists in South Australia and Victoria, the platform is built on the principles of integrity, transparency, and innovation.\n        "
                  )
                ]),
                _vm._v(" "),
                _c("br")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "Recognizing a crucial gap in the traditional real estate market, where off-the-plan properties required a unique marketing approach that standard open inspections couldn't address, they envisioned a platform offering an immersive online experience. This would enable potential buyers to thoroughly explore new properties before committing to a purchase.\n        "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "about-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "UNIFI Property was first launched as a B2B platform in August 2020, catering to real estate agents looking to showcase their clients' projects. As the platform gained momentum, Loretta and Michael saw an opportunity to expand its services directly to consumers. After three years of focused development, UNIFI Property was reintroduced in March 2024 as a public platform, providing a next-generation solution that enhances the buying and selling process for off-the-plan properties.\n        "
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e018dc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e018dc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/aboutUsContent.vue
// module id = null
// module chunks = 